import { render } from "./Inicio.vue?vue&type=template&id=1418e46b&scoped=true&ts=true"
import script from "./Inicio.vue?vue&type=script&lang=ts"
export * from "./Inicio.vue?vue&type=script&lang=ts"

import "./Inicio.vue?vue&type=style&index=0&id=1418e46b&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1418e46b"]])

export default __exports__